import { toUserTZ } from "@hydrologiq/common/helpers/date"
import { utc, DateTime } from "timezonecomplete"

/**
 * Formats an activity date for display in the activities table with time.
 *
 * @param dateString - ISO date string or null/undefined
 * @returns Formatted date and time string, or "n/a" for null/undefined
 */
export function formatActivityDate(dateString: string | null | undefined): string {
  if (!dateString) {
    return "n/a"
  }

  try {
    const dt: DateTime = toUserTZ(dateString, utc())
    // Format as "Jan 15, 2024, 09:30"
    return dt.format("MMM dd, yyyy, HH:mm")
  } catch (error) {
    console.error("Error formatting activity date:", error, dateString)
    return "n/a"
  }
}








